var map = {
	"./Auth/AuthRoutes": 4162,
	"./Content/Article/ArticleRoutes": 7675,
	"./Content/ArticleCategory/ArticleCategoryRoutes": 5815,
	"./Content/Branch/BranchRoutes": 2573,
	"./Content/Menu/MenuRoutes": 6183,
	"./Ecommerce/Brand/BrandRoutes": 7242,
	"./Ecommerce/Category/CategoryRoutes": 1974,
	"./Ecommerce/Collection/CollectionRoutes": 2555,
	"./Ecommerce/Home/HomeRoutes": 3278,
	"./Ecommerce/Order/OrderRoutes": 5431,
	"./Ecommerce/Product/ProductRoutes": 4765,
	"./Feedback/FeedbackRoutes": 1876,
	"./PushNotification/PushNotificationRoutes": 6190,
	"./Review/ReviewRoutes": 2974,
	"./Route/RouteRoutes": 2625,
	"./SearchKey/SearchKeyRoutes": 672,
	"./Subscription/SubscriptionRoutes": 2242
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9977;